<div class="news_content">
    <div class="news_title">
        @if(news.onTop){
            <ion-icon name="bookmark-outline"></ion-icon>
        }
        {{this.title}}
    </div>
    <div class="news_infos">
        @if(news.urlThumbnail && news.urlThumbnail != ''){
            <div 
                class="news_thumbnail"
                [class.with_media]="news.url && news.url != ''" 
                [class.is_video]="news.type === 'video'"
                (click)="this.showNewsMedia()"
                >
                <div class="news_play_video">
                    <ion-icon name="play-circle-outline"></ion-icon>
                </div>
                <img [src]="news.urlThumbnail" />
            </div>
        }
        <div class="news_description" [innerHTML]="this.description"></div>
    </div>
    <div class="news_likes">
        <demooz-button 
            type="button" 
            icon="thumbs-up-outline" 
            [class.is_liked]="this.isLiked"
            [invertColor]="!this.isLiked"
            color="primary"
            [isFetching]="this.isFetchingLike"
            (click)="this.likeNews()"
            />    
        <div class="news_nb_likes">{{this.news.likes?.length}}</div>
    </div>
</div>

<demooz-modal-media #modalMedia />